import { Screen } from '~/screens/groups/Index/index';

export const GroupsIndex: React.FC = () => <Screen />;
